import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { differenceInMilliseconds, parseISO } from 'date-fns';

import { useInterval } from '../../../../redux/opentok/hooks/useInterval';

function formatDuration(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return [h, m, s].map(n => String(n).padStart(2, '0')).join(':');
}

function CallDuration({
  time,
  timerActive,
  currentTimestamp,
  isConnectionRoom,
  previousDuration,
  currentSessionStartedAt,
}) {
  const [diff, setDiff] = useState(null);
  const duration = useMemo(() => {
    if (!diff) return '-';
    return formatDuration(diff);
  }, [diff]);

  const clearTime = useMemo(() => (time ? parseISO(time) : null), [time]);

  useEffect(() => {
    if (!isConnectionRoom && !timerActive && !diff) {
      setDiff((previousDuration || 0) * 1000);
    }
  }, [
    timerActive,
    previousDuration,
    isConnectionRoom,
    currentSessionStartedAt,
  ]);

  useInterval(() => {
    if (isConnectionRoom) {
      setDiff(differenceInMilliseconds(new Date(), clearTime));
    }
    if (!isConnectionRoom && timerActive) {
      setDiff(
        diff
          ? diff + 1000
          : (previousDuration || 0) * 1000 +
              (currentSessionStartedAt
                ? differenceInMilliseconds(
                    currentTimestamp ? parseISO(currentTimestamp) : new Date(),
                    parseISO(currentSessionStartedAt),
                  )
                : 0),
      );
    }
  }, 1000);

  return <div className="dib">{duration}</div>;
}

CallDuration.propTypes = {
  time: PropTypes.string,
  timerActive: PropTypes.bool,
  isConnectionRoom: PropTypes.bool,
  previousDuration: PropTypes.number,
  currentTimestamp: PropTypes.string,
  currentSessionStartedAt: PropTypes.string,
};

export default CallDuration;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/CallDuration/index.jsx